/* Category disclosure keyboard handling and accurate native header backfill. */
(() => {
  if (window.cgHeaderInstalled) return;
  window.cgHeaderInstalled = true;
  function setup() {
    document.querySelectorAll('.cg-header').forEach(header => {
      if (header.dataset.cgReady) return;
      header.dataset.cgReady = 'true';
      header.querySelectorAll('.cg-categories').forEach(details => {
        details.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            details.open = false;
            details.querySelector('summary').focus();
          }
        });
        details.addEventListener('focusout', event => {
          if (event.relatedTarget && !details.contains(event.relatedTarget)) details.open = false;
        });
      });
      const element = header.querySelector('[data-header-height]');
      const measure = () => {
        const height = element.getBoundingClientRect().height;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      };
      if (element && window.ResizeObserver) {
        const observer = new ResizeObserver(measure);
        observer.observe(element);
        const unload = event => {
          if (event.target.contains(header)) {
            observer.disconnect();
            document.removeEventListener('shopify:section:unload', unload);
          }
        };
        document.addEventListener('shopify:section:unload', unload);
      }
      if (element) measure();
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.cg-header .cg-categories[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('shopify:section:load', setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
